"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _isErrorRestResponse = require("./isErrorRestResponse");
Object.keys(_isErrorRestResponse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isErrorRestResponse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isErrorRestResponse[key];
    }
  });
});
var _isRestResponse = require("./isRestResponse");
Object.keys(_isRestResponse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isRestResponse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isRestResponse[key];
    }
  });
});
